import React, { useState } from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../../../template/MainTheme/components/Breadcrumbs';
import { Tabs, Tab } from 'react-bootstrap';
import QuoteTab from '../tabs/QuoteTab';
import { QuoteDataForm, QuoteOfferTypeDataForm, QuoteReferenceDataForm } from '../../../../app/models/Quote';
import { Society } from '../../../../app/models/Society';
import { Client } from '../../../../app/models/Client';
import { PaymentCondition } from '../../../../app/models/PaymentCondition';
import { Currency } from '../../../../app/models/Currency';
import { Sector } from '../../../../app/models/Sector';
import WarehouseStorageContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseStorageContainer';
import WarehouseQuoteExpeditionContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseExpeditionContainer';
import WarehouseQuoteRatesContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseRatesContainer';
import WarehouseQuoteExtraServiceContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseExtraServicesContainer';
import WarehouseQuoteDetailsContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseQuoteDetailContainer';
import DefaultCard from '../../../../components/default/DefaultCard';
import LazyLoading from '../../../../components/LazyLoading';
import WarehouseQuoteHistoryContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseHistoryContainer';
import { ClientContact } from '../../../../app/models/ClientContact';
import { ExchangeRateDate } from '../../../../app/models/ExchangeRateDate';
import { ExchangeRateDateSource } from '../../../../app/models/ExchangeRateDateSource';
import { QuoteInvoicingDataForm } from '../../../../app/models/QuoteInvoicing';
import QuoteInvoicingForm from '../forms/QuoteInvoicingForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';
import { Unit } from '../../../../app/models/Unit';

interface Props {
    id: number;
    quoteForm: QuoteDataForm;
    setQuoteForm: (quote: QuoteDataForm) => void;
    societies: Society[];
    clients: Client[];
    paymentConditions: PaymentCondition[];
    references: QuoteReferenceDataForm[];
    paymentMethods: PaymentCondition[];
    currencies: Currency[];
    offerTypes: QuoteOfferTypeDataForm[];
    sectors: Sector[];
    errorFields?: Record<string, unknown>;
    condition: boolean;
    disableUpdate: boolean;
    loadingClient: boolean;
    isEdit: boolean;
    fetchingQuote: boolean;
    update: () => void;
    sectorId: number;
    fetchingQuoteInvoicingByQuote: boolean;
    fetchingUpdateQuoteInvoicing: boolean;
    updateInvoicing: () => void;
    exchangeRateDate: ExchangeRateDate[];
    exchangeRateDateSource: ExchangeRateDateSource[];
    clientContacts: ClientContact[];
    quoteInvoicingForm: QuoteInvoicingDataForm;
    setQuoteInvoicingForm: (form: QuoteInvoicingDataForm) => void;
    units: Unit[];
}

const WareHouseQuoteEditContainer = ({
    id,
    quoteForm,
    setQuoteForm,
    societies,
    clients,
    paymentConditions,
    references,
    paymentMethods,
    currencies,
    offerTypes,
    sectors,
    errorFields,
    condition,
    disableUpdate,
    loadingClient,
    isEdit,
    fetchingQuote,
    update,
    sectorId,
    fetchingQuoteInvoicingByQuote,
    fetchingUpdateQuoteInvoicing,
    updateInvoicing,
    exchangeRateDate,
    exchangeRateDateSource,
    clientContacts,
    quoteInvoicingForm,
    setQuoteInvoicingForm,
    units,
}: Props) => {
    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Cotizaciones',
            url: '/quotes',
            isActive: false
        },
        {
            name: 'Editar cotización #' + id,
            url: '/quotes/' + id + '/edit',
            isActive: true
        }
    ];
    const [refreshKey, setRefreshKey] = useState(0);
    const [lastInvoicingUpdate, setLastInvoicingUpdate] = useState(Date.now());

    const handleInvoicingUpdate = async () => {
        updateInvoicing();
    };


    return (
        <>
            <Breadcrumbs pageSection={`Editar cotización WAREHOUSE #${id}`} breadcrumbs={breadcrumbs} />
            <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                <Tab eventKey="general-data" title="Datos Generales">
                    <QuoteTab
                        fetchingQuote={fetchingQuote}
                        update={update}
                        quoteForm={quoteForm}
                        setQuoteForm={setQuoteForm}
                        societies={societies}
                        clients={clients}
                        clientContacts = {clientContacts}
                        paymentConditions={paymentConditions}
                        references={references}
                        paymentMethods={paymentMethods}
                        offerTypes={offerTypes}
                        currencies={currencies}
                        sectors={sectors}
                        errorFields={errorFields}
                        condition={condition}
                        disableUpdate={disableUpdate}
                        loadingClient={loadingClient}
                        isEdit={isEdit}
                        updateSignal={lastInvoicingUpdate}
                        fetchingQuoteInvoicing = {fetchingUpdateQuoteInvoicing}
                    />
                </Tab>
                <Tab eventKey="storage" title="Almacenamiento">
                    <WarehouseStorageContainer quoteId={id} disableUpdate={disableUpdate} refresh={refreshKey}  />
                </Tab>

                <Tab eventKey="expedition" title="Expedición">
                    <WarehouseQuoteExpeditionContainer quoteId={id} disableUpdate={disableUpdate}  />
                </Tab>
                <Tab eventKey="extras" title="Servicios Adicionales">
                    <WarehouseQuoteExtraServiceContainer quoteId={id} disableUpdate={disableUpdate}/>
                </Tab>
                {/* <Tab eventKey="interlocutors" title="Interlocutores" disabled>
                    Interlocutores
                </Tab> */}
                <Tab eventKey="invoicing" title="Facturación">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Facturación</div>
                        {!fetchingQuoteInvoicingByQuote ? (
                            <>
                                <QuoteInvoicingForm
                                    quoteInvoicingDataForm={quoteInvoicingForm}
                                    setQuoteInvoicingDataForm={setQuoteInvoicingForm}
                                    currencies={currencies}
                                    references={references}
                                    paymentMethods={paymentMethods}
                                    exchangeRateDate={exchangeRateDate}
                                    exchangeRateSource={exchangeRateDateSource}
                                    errorFields={errorFields}
                                    units={units}
                                />
                                <div className="row justify-content-end">
                                    <div className="col-auto">
                                        <ButtonSaveForm
                                            callbackSave={handleInvoicingUpdate}
                                            locked={fetchingUpdateQuoteInvoicing}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </Tab>

                

                <Tab eventKey="rates" title="Tarifas del servicio">
                    <WarehouseQuoteRatesContainer quoteId={id} disableUpdate={disableUpdate} refresh={refreshKey} />
                </Tab>
                <Tab eventKey="management" title="Gestión" disabled>
                    Gestión
                </Tab>
                <Tab eventKey="history" title="Historial">
                    <WarehouseQuoteHistoryContainer quoteId={id} disableUpdate={disableUpdate} refresh={refreshKey} />
                </Tab>
            </Tabs>
            <WarehouseQuoteDetailsContainer
                quoteId={id}
                sectorId={sectorId}
                // disableUpdate={disableUpdate}
                // reloadQuote={handleUpdate}
                refresh={refreshKey}
                onDetailSaved={() => setRefreshKey(k => k + 1)}
            />

        </>
    );
};

export default WareHouseQuoteEditContainer;

